module.exports = __webpack_public_path__ + "img/instgram.c4205b04.png";